import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ICardEntry, IListCard } from './list-card.interface';

@Component({
  selector: 'app-list-card',
  templateUrl: './list-card.component.html',
  styleUrls: ['./list-card.component.scss']
})
export class ListCardComponent {
  @Input() card!: IListCard;

  @Output() edit = new EventEmitter();
  @Output() delete = new EventEmitter();

  emitEditAction() {
    this.edit.emit();
  }

  emitDeleteAction() {
    this.delete.emit();
  }

  trackByItems(item: ICardEntry) {
    return item;
  }
}
